export default "__VITE_ASSET__olPKYmsR__"